import { render, staticRenderFns } from "./InspectionPlanCommentModal.vue?vue&type=template&id=93c601ec&scoped=true&"
import script from "./InspectionPlanCommentModal.vue?vue&type=script&lang=js&"
export * from "./InspectionPlanCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c601ec",
  null
  
)

export default component.exports